import CertifiedBy from './CertifiedBy';

export default CertifiedBy;
